import { SVGProps } from "react"

export function KlaviyoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1541 1032"
      width="1541"
      height="1032"
      fill="currentColor"
      {...props}
    >
      <path d="m1541 1031.8h-1540.8v-1031.8h1540.8l-323.2 516.3z" />
    </svg>
  )
}
